import * as tslib_1 from "tslib";
import { EventEmitter } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { LangsRepository } from 'src/app/services/langs.repository';
import { ProcessesRepositoryBUT } from 'src/app/services/processes.repository.but';
import { SubstatusesRepository } from 'src/app/services/substatuses.repository';
import { AppService } from '../../services/app.service';
export class SubStatusNewOverlayComponent {
    constructor(appService, langsRepository, substatusesRepository, processesRepository, loadingCtrl) {
        this.appService = appService;
        this.langsRepository = langsRepository;
        this.substatusesRepository = substatusesRepository;
        this.processesRepository = processesRepository;
        this.loadingCtrl = loadingCtrl;
        this.ready = false;
        this.activeChange = new EventEmitter();
        this.cancel = new EventEmitter();
        this.globalStatus = 0;
        this.clientProcessId = 0;
        this.langsReady = false;
        this.substatusesReady = false;
        this.processesReady = false;
        this.substatus = { title: "", statusId: null, template: "", position: 0 };
        this.advanced = false;
        this.ready = true;
        this.init();
    }
    close() {
        this.active = false;
        this.activeChange.emit(false);
    }
    init() {
        this.langsRepository.ready.subscribe(r => { if (r) {
            this.langsReady = true;
        } });
        this.processesRepository.prepare().then(() => { this.processesReady = true; });
        this.substatus = { title: "", statusId: null, template: "", position: 0 };
        this.substatusesRepository.prepare().then(() => { this.substatusesReady = true; });
    }
    get statuses() {
        var process = this.processesRepository.processes[0];
        return process ? process.statuses : [];
    }
    validate() {
        let err = false;
        if (!this.substatus.title.trim().length) {
            this.substatus.titleError = this.currentLang.words['enter-status'];
            err = true;
        }
        else if (this.substatus.title.trim().length > 250) {
            this.substatus.titleError = this.currentLang.words['substatus-limit-error'];
            err = true;
        }
        else if (!/^[0-9a-zA-Z\u0590-\u05FF _-]+$/.test(this.substatus.title)) {
            this.substatus.titleError = this.currentLang.words['substatus-title-error'];
            err = true;
        }
        else {
            this.substatus.titleError = "";
        }
        if (!this.substatus.position) {
            this.substatus.positionError = this.currentLang.words['substatus-position-error'];
            err = true;
        }
        if (this.substatus.position && this.substatus.position.toString().length > 10) {
            this.substatus.positionError = this.currentLang.words['substatus-position-error'];
            err = true;
        }
        if (!this.substatus.statusId) {
            this.substatus.statusIdError = this.currentLang.words['enter-status-stage'];
            err = true;
        }
        else {
            this.substatus.statusIdError = "";
        }
        return !err;
    }
    save() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.substatus.template = this.appService.formatText(this.substatus.template);
            this.substatus.statusId = this.globalStatus;
            this.substatus.clientProcessId = this.clientProcessId;
            if (this.validate()) {
                this.appService.showNetworkstatus("sending data...");
                if (this.substatus.clientProcessId == null) {
                    this.substatus.clientProcessId = this.processesRepository.processes[0].id;
                }
                if (this.substatus.clientProcessId === 0) {
                    const defaultProcesses = this.processesRepository.processes.filter((i) => i.isDefault);
                    if (defaultProcesses.length > 0) {
                        this.substatus.clientProcessId = defaultProcesses[0].id;
                    }
                }
                const loading = yield this.loadingCtrl.create({
                    message: this.currentLang.words["wait"],
                });
                loading.present();
                this.substatusesRepository.sendAddSubstatus(this.substatus).subscribe(res => {
                    if (res.responseCode === 200) {
                        this.appService.showNetworkstatus("sent ok");
                        this.substatusesRepository.substatuses.push(res.data);
                        this.processesRepository.load();
                        this.substatusesRepository.load();
                        this.substatusesRepository.sort();
                        this.close();
                        this.substatus = { title: "", statusId: null, template: "", position: 0 };
                    }
                    else if (res.responseCode === 400) {
                        this.substatus.titleError = this.currentLang.words['status-exist'];
                    }
                    else {
                        this.appService.showError("API error", res.error || res.Error, true, res.responseCode);
                    }
                    loading.dismiss();
                }, err => {
                    loading.dismiss();
                    const message = this.appService.getErrorMessage(err);
                    this.appService.showError("HTTP error", `${this.currentLang.words["http_error"]} in substatus-new-overlay save sendAddSubstatus: ${message}`, true);
                });
            }
        });
    }
}
